
import React from 'react';
import { PropertyField } from '../../molecules/PropertyField';
import { WorkflowNodeData } from '../../../types';

interface UserTaskExtensionTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const UserTaskExtensionTab: React.FC<UserTaskExtensionTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 space-y-6">
            <div className="space-y-4">
                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Engine Properties</h3>
                <div className="grid grid-cols-2 gap-4">
                    <PropertyField
                        config={{ name: 'userTaskSubject', label: 'Subject', type: 'text', placeholder: 'Leave empty to use node label', description: 'Task subject shown to the user.' }}
                        value={data.userTaskSubject}
                        onChange={onChange}
                    />
                    <PropertyField
                        config={{ name: 'userTaskObject', label: 'Object', type: 'text', placeholder: 'e.g. ${variables.objectId}', description: 'Business object reference.' }}
                        value={data.userTaskObject}
                        onChange={onChange}
                    />
                </div>
                <div className="grid grid-cols-3 gap-4">
                    <PropertyField
                        config={{ name: 'userTaskModifiers', label: 'Modifiers', type: 'text', placeholder: 'e.g. readonly' }}
                        value={data.userTaskModifiers}
                        onChange={onChange}
                    />
                    <PropertyField
                        config={{ name: 'userTaskStep', label: 'Step', type: 'number', defaultValue: 1, description: 'Workflow step number.' }}
                        value={data.userTaskStep}
                        onChange={onChange}
                    />
                    <div>
                        <PropertyField
                            config={{ name: 'userTaskRejectable', label: 'Rejectable', type: 'boolean', defaultValue: true, description: 'Allow task rejection.' }}
                            value={data.userTaskRejectable ?? true}
                            onChange={onChange}
                        />
                        <p className="text-[10px] text-slate-400 mt-1">Toggling will auto-manage the Error Boundary Event.</p>
                    </div>
                </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-slate-200 dark:border-slate-800">
                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Common Extensions</h3>
                <PropertyField
                    config={{ name: 'extensionConfig', label: 'Configuration (JSON)', type: 'object', rows: 4 }}
                    value={data.extensionConfig}
                    onChange={onChange}
                />
                <PropertyField
                    config={{ name: 'extensionRelations', label: 'Relations (JSON)', type: 'object', rows: 4 }}
                    value={data.extensionRelations}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};
